import { Pipe, PipeTransform } from '@angular/core';
import { ProcessingStatusEntities } from '../../_helpers/processing-status.helper';
import { ProcessingStatus } from 'src/app/_entities/orders/processing-statuses/processing-status';

@Pipe({
    name: 'latestProcessingStatus',
    pure: true
})
export class LatestProcessingStatusPipe implements PipeTransform {
    transform(context: ProcessingStatusEntities): string {
        if (context.latestProcessingStatus.value === ProcessingStatus.None.value) {
            return ProcessingStatus.Open.readable();
        }
        return context.latestProcessingStatus.readable();
    }
}
